export const MEDIA_BUCKET = 'asset-note-media'
export const MAX_FILES = 5
export const MAX_BYTES = 10 * 1024 * 1024
export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif']
export const AUDIO_TYPES = ['audio/webm', 'audio/mp4', 'audio/ogg', 'audio/mpeg', 'audio/wav']
export function validateMedia(file, imagesOnly = false) {
  const type = file.type.split(';')[0]
  if (!(imagesOnly ? IMAGE_TYPES : [...IMAGE_TYPES, ...AUDIO_TYPES]).includes(type)) throw new Error('Choose a PNG, JPEG, WebP, GIF' + (imagesOnly ? ' image.' : ' image or an audio file.'))
  if (!file.size || file.size > MAX_BYTES) throw new Error('Each attachment must be between 1 byte and 10 MB.')
  return type
}
export async function uploadMedia(client, owner, files, imagesOnly = false) {
  if (!owner) throw new Error('Sign in to attach files.')
  if (files.length > MAX_FILES) throw new Error('Attach up to five files per note or alert.')
  files.forEach(file => validateMedia(file, imagesOnly))
  const uploaded = []
  try {
    for (const file of files) {
      const type = validateMedia(file, imagesOnly)
      const path = `${owner}/${crypto.randomUUID()}`
      const { error } = await client.storage.from(MEDIA_BUCKET).upload(path, file, { contentType: type, upsert: false })
      if (error) throw error
      uploaded.push({ path, type, name: file.name || 'Voice note', size: file.size })
    }
    return uploaded
  } catch (error) {
    if (uploaded.length) await client.storage.from(MEDIA_BUCKET).remove(uploaded.map(item => item.path)).catch(() => {})
    throw error
  }
}
export async function loadAlertReference(client, owner, alertId, revision) {
  if (!owner || !alertId || !revision) return []
  const { data, error } = await client.from('alert_references').select('attachments').eq('user_id', owner).eq('alert_id', alertId).lte('revision', revision).order('revision', { ascending: false }).limit(1)
  if (error) throw error
  return data?.[0]?.attachments || []
}
